@if (displayData?.faultStatus; as faultStatus) {
  <div class="col-auto">
    <span class="badge border-radius-sm d-flex"
          [ngClass]="'text-bg-' + (displayData.faultStatus === TicketFaultStatus.FAULT ? colorByAlertStatus.get(displayData.faultStatus) : 'info-gray')">
      {{faultStatus === TicketFaultStatus.FAULT ? ('In fault' | messageTranslate) : ('Recovered' | messageTranslate)}}
      @if (displayData.lastFaultTransitionedAt; as lastFaultTransitionedAt) {
        <span class="ms-1 opacity-75">
          {{(lastFaultTransitionedAt | timeAgo:{abbreviated: true, compact: true})}}
        </span>
      }
    </span>
  </div>
}
